export default __webpack_public_path__ + "static/media/Group 3321 mob@2x.03d47fb1.png";